<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditChatBanDialog(true)"
      >新增禁言项</el-button
    >

    <div @keyup.enter="onClickQueryBtn()">
      <el-form
        ref="form"
        :model="form"
        label-width="130px"
        size="mini"
        style="margin-top: 30px"
      >
        <el-form-item label="查询方式：">
          <el-radio-group v-model="form.queryType">
            <el-radio label="">全部</el-radio>
            <el-radio label="uid">按UID</el-radio>
            <el-radio label="aid">按AID</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.queryType != ''"
          :label="form.queryType == 'uid' ? 'UID：' : 'AID：'"
        >
          <el-input
            v-model="form.queryValue"
            clearable
            style="width: 172px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="chatBanListTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="chatBanListTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 971px; margin-left: 120px"
    >
      <el-table-column prop="when" label="时间" align="center" width="140" />
      <el-table-column label="UID" align="center" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.uid > 0">
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage(scope.row, 'uid')"
            >
              {{ scope.row.uid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="name" label="昵称" align="center" width="110" />
      <el-table-column label="AID" align="center" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.aid > 0">
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage(scope.row, 'aid')"
            >
              {{ scope.row.aid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="thirdPartyId"
        label="第三方账号ID"
        align="center"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="300"
        show-overflow-tooltip
      />
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="onClickDeleteChatBanBtn(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      chatBanListTableData: [], // 禁言列表里展示的数据
      form: {
        queryType: "",
        queryValue: "",
      },
    };
  },

  methods: {
    loadMore() {
      this.loadChatBanList(this.chatBanListTableData.length, 20);
    },

    /**
     * 跳转到玩家详情界面
     * @param {*} entry
     */
    toRouterPlayerInfoPage(entry, condition) {
      var query = {};
      switch (condition) {
        case "uid": {
          query = { uid: entry.uid, tab: "playerList" };
          break;
        }
        case "aid": {
          query = { aid: entry.aid, tab: "playerList" };
          break;
        }
      }
      query["tab"] = "playerList";
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },

    /**
     * 点击了禁言项的删除按钮
     * @param {*} entryId
     */
    onClickDeleteChatBanBtn(entryId) {
      this.$confirm("此操作将删除该禁言项，是否继续?", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteChatBan(entryId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },

    /**
     * 查询禁言列表
     */
    async loadChatBanList(skip, limit) {
      switch (this.form.queryType) {
        case "": {
          // 全量查

          // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
          if (skip == 0) {
            this.chatBanListTableData = [];
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/admin/queryChatBanList`,
              {
                skip: skip,
                limit: limit,
              },
              {
                headers: {
                  token: bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.entries || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              id: e.id,
              uid: e.uid,
              name: e.name,
              aid: e.aid,
              thirdPartyId: e.thirdPartyId,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
              remark: e.remark,
            });
          }

          this.chatBanListTableData = this.chatBanListTableData.concat(list);

          break;
        }
        default: {
          // 根据uid查
          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/admin/queryChatBanListByType`,
              {
                byType: this.form.queryType,
                byValue: this.form.queryValue,
              },
              {
                headers: {
                  token: bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.entries || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              id: e.id,
              uid: e.uid,
              name: e.name,
              aid: e.aid,
              thirdPartyId: e.thirdPartyId,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.chatBanListTableData = list;

          break;
        }
      }
    },

    /**
     * 删除一个禁言项
     */
    async deleteChatBan(entryId) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/deleteChatBan`,
          {
            entryId: entryId,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.$message({
        type: "success",
        message: "删除成功!",
      });

      // 重新拉禁言列表
      return this.loadChatBanList(0, 20);
    },

    /**
     * 打开“添加/修改禁言项”对话框
     */
    async openEditChatBanDialog(isCreate, oldData) {
      dialogutil.open("EditChatBanDialog");
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      await this.loadChatBanList(0, 20);
    },
  },
};
</script>
